import { render, staticRenderFns } from "./ModalShareNewOld.vue?vue&type=template&id=589ca904&scoped=true"
import script from "./ModalShareNewOld.vue?vue&type=script&lang=js"
export * from "./ModalShareNewOld.vue?vue&type=script&lang=js"
import style0 from "./ModalShareNewOld.vue?vue&type=style&index=0&id=589ca904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ca904",
  null
  
)

export default component.exports